import { useEffect, useState } from 'react';
import styled from 'styled-components';
import SectionTitle from '../components/SectionTitle';
import ContactCard from '../components/ContactCard';
import OpeningHours from '../components/OpeningHours';
import { getSettings, getOpeningHours } from '../services/settingsService';

const Section = styled.section`
  max-width: 1200px;
  margin: 0 auto;
  padding: 3rem 1.5rem 4rem;
`;

const TopGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  align-items: start;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const KitchenNoteWrap = styled.div`
  margin-top: 1.75rem;
`;

const KitchenNote = styled.div`
  background: linear-gradient(
    135deg,
    rgba(122, 31, 43, 0.08) 0%,
    rgba(122, 31, 43, 0.04) 100%
  );
  border-left: 5px solid #7a1f2b;
  border-radius: 18px;
  padding: 1rem 1.25rem;
  color: #4a4a4a;
  font-size: 1rem;
  line-height: 1.7;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.04);
`;

function ContactPage() {
  const [settings, setSettings] = useState(null);
  const [openingHours, setOpeningHours] = useState([]);

  useEffect(() => {
    const loadData = async () => {
      setSettings(await getSettings());
      setOpeningHours(await getOpeningHours());
    };

    loadData();
  }, []);

  if (!settings) return null;

  return (
    <Section>
      <SectionTitle>Kontakt</SectionTitle>

      <TopGrid>
        <ContactCard
          name={settings.name}
          address={settings.address}
          phone={settings.phone}
          email={settings.email}
        />

        <OpeningHours items={openingHours} />
      </TopGrid>

      <KitchenNoteWrap>
        <KitchenNote>
          Küchenzeiten täglich von <strong>11:00 Uhr</strong> bis <strong>20:00 Uhr</strong>,
          außer an den Ruhetagen.
        </KitchenNote>
      </KitchenNoteWrap>
    </Section>
  );
}

export default ContactPage;